
    import { VueAgile } from 'vue-agile';

    export default {
        name: 'OtherServices',
        components: {
            agile: VueAgile,
        },
        data() {
            return {
                options: {
                    navButtons: false,
                    centerMode: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                fade: false,
                                mobileFirst: true,
                            },
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 3,
                                fade: false,
                                mobileFirst: true,
                            },
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 5,
                                fade: false,
                                mobileFirst: false,
                            },
                        },
                    ],
                },
            };
        },
        computed: {
            servicesBlock() {
                return this.$store.state.servicesData;
            },
        },
        methods: {
            redirectToPage(slug) {
                this.$router.push(`/paslaugos/${slug}`);
            },
        },
    };
